export type ResponseTextFormat = 'bold' | 'italic' | 'strikethrough';

export interface FormattedText {
  message: string;
  caret: number;
}

// WhatsApp markers the automatic response editors wrap a selection with (WhatsApp has no underline).
const FORMAT_MARKERS: Readonly<Record<ResponseTextFormat, string>> = {
  bold: '*',
  italic: '_',
  strikethrough: '~',
};

// Text edits shared by the automatic response card and its caption dialog.
export class ResponseMessageUtil {

  // null when nothing is selected.
  static format(message: string, start: number, end: number, format: ResponseTextFormat): FormattedText | null {
    const selected = (message ?? '').substring(start, end);
    if (!selected) {
      return null;
    }
    const formatted = `${FORMAT_MARKERS[format]}${selected}${FORMAT_MARKERS[format]}`;
    return {
      message: message.substring(0, start) + formatted + message.substring(end),
      caret: start + formatted.length,
    };
  }

  static appendVariable(message: string, variable: string): string {
    return `${message || ''} ${variable}`.trim();
  }

  static appendEmoji(message: string, emoji: string): string {
    return (message ?? '') + emoji;
  }

  // An edit fits when there is no limit, when it stays within it, or when it does not grow the text.
  static fits(next: string, previous: string, limit: number | null): boolean {
    return limit === null || next.length <= limit || next.length <= (previous?.length ?? 0);
  }
}
